import { render, staticRenderFns } from "./question-subDetails.vue?vue&type=template&id=21c804fa&scoped=true"
import script from "./question-subDetails.vue?vue&type=script&lang=js"
export * from "./question-subDetails.vue?vue&type=script&lang=js"
import style0 from "./question-subDetails.vue?vue&type=style&index=0&id=21c804fa&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21c804fa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_business_lcPT/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('21c804fa')) {
      api.createRecord('21c804fa', component.options)
    } else {
      api.reload('21c804fa', component.options)
    }
    module.hot.accept("./question-subDetails.vue?vue&type=template&id=21c804fa&scoped=true", function () {
      api.rerender('21c804fa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/viewsteacher/teacher/question-subDetails.vue"
export default component.exports